import {Selector} from '@ngxs/store';
import {FilterObject} from '../../../shared/models/FilterBarObject';
import {EventAlert, EventAlertDetails, EventConfigurationMetaData} from '../../models/events/event-interface';
import {EventsState} from './events-state';
import {EventsFilter, EventsStateModel} from './events.model';

export class EventsSelectors {

  @Selector([EventsState])
  static eventsFilter(state: EventsStateModel): FilterObject<EventsFilter> {
    return state.eventsFilter;
  }

  @Selector([EventsState])
  static configuration(state: EventsStateModel): EventConfigurationMetaData {
    return state.configuration;
  }

  @Selector([EventsState])
  static isTouched(state: EventsStateModel): boolean {
    return state.isTouched;
  }

  @Selector([EventsState])
  static count(state: EventsStateModel): number {
    return state.totalEventsCount;
  }

  @Selector([EventsState])
  static events(state: EventsStateModel): EventAlert[] {
    return state.events;
  }

  @Selector([EventsState])
  static eventsFiltered(state: EventsStateModel): EventAlert[] {
    return state.eventsFiltered;
  }

  @Selector([EventsState])
  static realTimeEvents(state: EventsStateModel): EventAlert[] {
    return state.realTimeEvents;
  }

  @Selector([EventsState])
  static currentPage(state: EventsStateModel): number {
    return state.currentPage;
  }

  @Selector([EventsState])
  static selectedEvent(state: EventsStateModel): EventAlertDetails {
    return state.selectedEvent;
  }

  @Selector([EventsState])
  static isLoadingData(state: EventsStateModel): boolean {
    return state.isLoadingData;
  }

  @Selector([EventsState])
  static isPrinting(state: EventsStateModel): boolean {
    return state.isPrinting;
  }
}
